import React from 'react';
import { Spinner } from 'react-bootstrap';

const QueryIndicator = () => (
  <div style={{ padding: 5, display: 'flex', justifyContent: 'center' }}>
    <Spinner animation="border" role="status" variant="primary">
      <span className="visually-hidden">Chargement...</span>
    </Spinner>
  </div>
);

export default QueryIndicator;
